import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../contexts/AuthContext";
import { forgotPasswordSchema } from "../../utils/validationSchemas";
import LoadingSpinner from "../LoadingSpinner";
import "./AuthForms.css";

const ForgotPasswordForm = ({ onSwitchToLogin }) => {
  const { isLoading, error, clearError, forgotPassword } = useAuth();
  const [emailSent, setEmailSent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    getValues,
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    clearError();

    const result = await forgotPassword(data.email);
    if (result.success) {
      console.log("Forgot password successful:", result.data);
      setEmailSent(true);
    }
    // Error handling is managed by AuthContext
  };

  if (emailSent) {
    return (
      <div className="auth-form">
        <div className="auth-header">
          <h2>Check your email</h2>
          <p>
            We've sent a password reset link to{" "}
            <strong>{getValues("email")}</strong>
          </p>
        </div>

        <div className="success-message">
          <p>
            If an account with that email exists, you'll receive a password
            reset link within a few minutes.
          </p>
          <p>
            Please check your email and follow the instructions to reset your
            password.
          </p>
        </div>

        <div className="form-footer">
          <p>
            Remember your password?{" "}
            <button
              type="button"
              className="link-button primary"
              onClick={onSwitchToLogin}
            >
              Back to sign in
            </button>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form">
      <div className="auth-header">
        <h2>Reset your password</h2>
        <p>
          Enter your email address and we'll send you a link to reset your
          password
        </p>
      </div>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit(onSubmit)} className="form">
        <div className="form-group">
          <label htmlFor="email">Email address</label>
          <input
            id="email"
            type="email"
            {...register("email")}
            className={errors.email ? "input-error" : ""}
            placeholder="Enter your email address"
            autoComplete="email"
          />
          {errors.email && (
            <span className="field-error">{errors.email.message}</span>
          )}
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={isLoading || isSubmitting}
        >
          {isLoading || isSubmitting ? (
            <LoadingSpinner size="small" />
          ) : (
            "Send reset link"
          )}
        </button>

        <div className="form-footer">
          <p>
            Remember your password?{" "}
            <button
              type="button"
              className="link-button primary"
              onClick={onSwitchToLogin}
            >
              Back to sign in
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
